import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import useSeo from "@/hooks/useSeo";
import NotFound from "@/pages/NotFound";
import BlogArticle from "@/components/site/BlogArticle";
import { blogPostingLd, blogBreadcrumbLd } from "@/lib/jsonld";
import { ContentLoading } from "@/lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPost() {
    const { slug } = useParams();
    const [state, setState] = useState({ loading: true, post: null });

    useEffect(() => {
        let alive = true;
        setState({ loading: true, post: null });
        axios
            .get(`${API}/blog/posts/${encodeURIComponent(slug)}`)
            .then((r) => alive && setState({ loading: false, post: r.data }))
            .catch(() => alive && setState({ loading: false, post: null }));
        return () => {
            alive = false;
        };
    }, [slug]);

    const post = state.post;
    useSeo({
        title: post ? `${post.seo_title || post.title} | Human Design Studio` : undefined,
        description: post ? post.seo_description || post.excerpt || "" : undefined,
        path: post ? `/blog/${post.slug}` : undefined,
        jsonLd: post ? [blogPostingLd(post), blogBreadcrumbLd(post.title, post.slug)] : undefined,
    });

    if (state.loading) return <ContentLoading />;
    // Concept, verwijderd of onbekend: nooit publiek bereikbaar
    if (!post) return <NotFound />;

    return (
        <section
            data-testid="page-blog-post"
            className="mx-auto max-w-[880px] px-5 md:px-10 pt-24 md:pt-40 pb-24 md:pb-36"
        >
            <BlogArticle post={post} />
        </section>
    );
}
